import { useNavigation } from '@atom/hooks/useNavigation';
import { Icon, IconButton } from '@atom/mui';
import colors from '@atom/styles/colors';
import {
  AssetDetailView,
  InventoryAssetDetailType,
} from '@atom/types/inventory';

import classes from './header.module.css';

interface Props {
  asset: InventoryAssetDetailType;
}

const styles = {
  disabled: {
    opacity: '40%',
  },
};

const AssetDetailPagination = ({ asset: { cursor } }: Props) => {
  const [{ activeView: viewParam }, { navigate }] = useNavigation();

  const handleChange = (id: string) => {
    const activeView = viewParam || AssetDetailView.ASSET_INFO;
    navigate(`/inventory/${id}?activeView=${activeView}`);
  };

  const isDisabled = cursor.total === 1;

  return (
    <>
      <div className={classes.paginationContainer}>
        {cursor.index + 1} of {cursor.total}
        <IconButton
          disabled={isDisabled}
          onClick={() => handleChange(cursor.previous)}
        >
          <Icon
            style={isDisabled ? styles.disabled : {}}
            color={colors.neutral.white}
          >
            keyboard_arrow_left
          </Icon>
        </IconButton>
        <IconButton
          disabled={isDisabled}
          onClick={() => handleChange(cursor.next)}
        >
          <Icon
            style={isDisabled ? styles.disabled : {}}
            color={colors.neutral.white}
          >
            keyboard_arrow_right
          </Icon>
        </IconButton>
      </div>
      <div className={classes.paginationDivider} />
    </>
  );
};

export default AssetDetailPagination;
